// @flow

import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  ical: string,
  link: string,
  start_day: string,
  start_hour: string,
  title: string,
  label: ?string,
  venue: ?string,
  venue_city: ?string,
  venue_zip: ?string,
};

export default class CardEvent extends PureComponent<Props> {
  renderDownloadCalendar = (address: string) => {
    const {
      ical
    } = this.props;

    return (
      <a href={ical} download={true} className="btn btn--primary btn--full">
        <i className="icon icon-calendar is-inline"></i>
        <span>Ajouter à mon calendrier</span>
      </a>
    );
  };

  render() {
    const { title, start_day, start_hour, venue, venue_city, venue_zip, link, label } = this.props;
    let address = '';
    if (venue_city && venue_zip) {
      address = `${venue_city}, ${venue_zip}`;
    } else if (venue_city) {
      address = `${venue_city}`;
    } else if (venue_zip) {
      address = `${venue_zip}`;
    }

    return (
      <div className="box event event--small ">
        <Link
          to={link}
          className="tag is-active mt-2 tag--small">
          {label ? label : 'Évènement'}
        </Link>
        <h3 className="mt-3 mb-3"><Link to={link}>{title}</Link></h3>
        <hr />
        <div className="event__row">
          <p className="ft-700">
            <i className="ft-black-secondary icon icon-calendar" />
            {start_day}
          </p>
          <span>{start_hour}</span>
        </div>
        <div className="event__row">
          <p className="ft-700">
            <i className="ft-black-secondary icon icon-place" />
            {venue}
          </p>
          <span>{address}</span>
        </div>
        {this.renderDownloadCalendar(address)}
      </div>
    );
  }
}
